<div class="full-width" align="center">
  {{ 'campaign.message.confirm_reset' | translate }}
</div>
